import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";

const SearchField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    paddingTop: 0,
    paddingBottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    borderRadius: 12,
    border: '1px solid rgba(226, 232, 240, 0.8)',
    transition: 'all 0.2s ease',
    "& fieldset": {
      border: 'none',
    },
    "&:hover": {
      backgroundColor: "#ffffff",
      borderColor: "#818cf8",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
    },
    "&.Mui-focused": {
      backgroundColor: "#ffffff",
      borderColor: "#6366f1",
      boxShadow: "0 0 0 4px rgba(99, 102, 241, 0.1)",
    },
  },
  "& .MuiInputBase-root": {
    height: '44px',
    fontSize: '0.875rem',
  },
  "& .MuiInputLabel-root": {
    color: "#64748b",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#6366f1",
  },
});

export default SearchField;
